<template>
  <full-bleed-layout class="home" show-leaderboard-ad>
    <not-found />
  </full-bleed-layout>
</template>

<script>
import NotFound from '@/components/Global/NotFound.vue';

export default {
  name: 'NotFoundPage',
  components: {
    NotFound,
  },
  beforeCreate() {
    this.$store.dispatch('setIs404', true);
  },
};
</script>
